import React from 'react'
import {DataBuyer} from '../Modules/BuyerUser/DataBuyer'

interface Props {
  dataBuyer: DataBuyer
}

const DataBuyerHeader = (props: Props) => {
  const {dataBuyer} = props
  console.log('DataBuyerHeader - dataBuyer: ', dataBuyer)
  if (!dataBuyer) {
    return (
      <>
        <div className="bg-blue-t0">
          <>
            <div style={{textAlign: 'center'}}>
              <h3 style={{color: 'white'}}><span>
              {'¿Ya eres cliente?'}
                <a
                  className="text-white ml-3"
                  href="#"
                  onClick={() => {
                  }}>
              {'Inicia sesión'}
            </a>
            </span></h3>
            </div>
          </>
        </div>
      </>

    )
  }
  return (
    <>
      <div className="bg-blue-t0">
        {dataBuyer && dataBuyer.client && <>
          <div style={{textAlign: 'center'}}>
            <h4 style={{color: 'white'}}>{`${dataBuyer.client.name}`}</h4>
          </div>
          <hr/>
          <div style={{textAlign: 'center'}}>
            <h4 style={{color: 'white'}}>{`${dataBuyer.user.name} - ${dataBuyer.user.surname}`}</h4>
            <h4 style={{color: 'white'}}>{`${dataBuyer.user.email}`}</h4>
          </div>
        </>}
      </div>
    </>
  )
}

export default DataBuyerHeader